import vue from 'vue';
import toastComponent from './Toast';
const ToastConstructor = vue.extend(toastComponent);
function showToast(text, subText, cancelText, sureText, twoBtnFlag, cb) {
  const toastDom = new ToastConstructor({
    el: document.createElement('div'),
    data() {
      return {
        toastText: text,
        toastSubText: subText,
        cancelText: cancelText,
        sureText: sureText,
        twoBtnFlag: twoBtnFlag,
        toastIsShow: true,
        showAnimateContent: true
      };
    },
    methods: {
      clickCancel() {
        toastDom.showAnimateContent = false;
        setTimeout(function () {
          toastDom.toastIsShow = false;
        }, 300);
      },
      clickSure() {
        toastDom.showAnimateContent = false;
        cb && cb();
        setTimeout(function () {
          toastDom.toastIsShow = false;
        }, 300);
      },
      clickIKnow() {
        toastDom.showAnimateContent = false;
        setTimeout(() => {
          toastDom.toastIsShow = false;
        }, 300);
      }
    }
  });
  document.body.appendChild(toastDom.$el);
}
function registryToast() {
  vue.prototype.$toast = showToast;
}
export default registryToast;